import * as actions from './actions';
import container from './container';
import * as constants from './constants';
import reducer from './reducer';
import * as selectors from './selectors';

export default { actions, container, constants, reducer, selectors };
